import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import Tokens from '@uipath/apollo-core';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { useIntl } from 'react-intl';

import { UiLogo } from '../UiLogo';
import { UiText } from '../UiText/UiText';

const useStyles = makeStyles(theme =>
    createStyles({
        root: {
            display: 'flex',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
        },
        leftContainer: {
            background: theme.palette.semantic.colorPrimary,
            display: 'flex',
            width: '400px',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'left',
            padding: '50px 50px',
        },
        leftContainerText: {
            color: theme.palette.semantic.colorBackground,
            fontFamily: Tokens.FontFamily.FontTitle,
            fontWeight: 800,
            fontSize: '56px',
            lineHeight: '64px',
            width: '250px',
            wordBreak: 'break-word',
            minHeight: '250px',
        },
        '@media all and (max-width: 1100px)': { leftContainer: { display: 'none' } },
    }),
);

interface IErrorObject {
    ErrorComponent: React.ReactNode;
    renderError: boolean;
}

export const UiSignupLayoutRevamp = ({
    children, error, isActIILogo,
}: PropsWithChildren<{ error?: IErrorObject; isActIILogo?: boolean }>) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();

    const theme = useTheme();

    return <div className={classes.root}>
        <div className={classes.leftContainer}>
            <UiLogo
                color={theme.palette.semantic.colorBackground}
                data-cy="uipath-logo"
                isActII={isActIILogo} />
            <UiText
                className={classes.leftContainerText}
                data-cy="ui-signup-left-bar-title">
                {translate({ id: 'CLIENT_OFFERS_REVAMP_SIDEBAR_TEXT' })}
            </UiText>
        </div>
        <div style={{
            flex: 1,
            overflow: 'auto',
        }} >
            {error?.renderError ? <div style={{ marginTop: '80px' }}>
                {error.ErrorComponent}
            </div> : children}
        </div>
    </div>;
};
